import { UntypedFormControl } from '@angular/forms';

export class PriceSheet {
  _id: UntypedFormControl;
  priceSheetName: UntypedFormControl;
  priceZone: UntypedFormControl;
  priceSheetNumber: UntypedFormControl;
  supersededPriceSheetNumber: UntypedFormControl;
  currencyCode: UntypedFormControl;
  effectiveDate: UntypedFormControl;
  expirationDate: UntypedFormControl;
  isNewRow: UntypedFormControl;
  primary: UntypedFormControl;
  secondary: UntypedFormControl;
}
